export const API = "API";
export const SET_USER_INFO = "SET_USER_INFO";
export const RETURN_INFO = "RETURN_INFO";
export const TOGGLE_LOADER = "TOGGLE_LOADER";
export const RESET_USER_INFO = "RESET_USER_INFO";
export const LOAD_CONFIGS = "LOAD_CONFIGS";
export const LOAD_CONFIGS_PROFILE = "LOAD_CONFIGS_PROFILE";
export const SET_NEW_USER = "SET_NEW_USER";
export const SET_USER_INFO_AFTER_ACCOUNT = "SET_USER_INFO_AFTER_ACCOUNT";
export const SET_USER_FAV_FUEL_LOCATIONS = "SET_USER_FAV_FUEL_LOCATIONS";
export const SET_USER_ALL_FUEL_LOCATIONS = "SET_USER_ALL_FUEL_LOCATIONS";
export const SET_USER_SINGLE_FUEL_LOCATION = "SET_USER_SINGLE_FUEL_LOCATION";
export const GET_TRIP_DEFAULTS = "GET_TRIP_DEFAULTS";
export const GET_SPARKLINE_DATA = "GET_SPARKLINE_DATA";
export const GET_FILTERED_CONFIG = "GET_FILTERED_CONFIG";

// ***************************************** Refresh Token **************************************
export const REFRESH_TOKEN = "REFRESH_TOKEN";

export const SET_ALL_NOTES = "SET_ALL_NOTES";
export const ADD_NOTE = "ADD_NOTE";
export const REMOVE_NOTE = "REMOVE_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const GET_PNL_MONTHS = "GET_PNL_MONTHS";
export const GET_PNL_MONTHLY_WISE = "GET_PNL_MONTHLY_WISE";
export const GET_PARTY_LEDGER_DATA = "GET_PARTY_LEDGER_DATA";
export const GET_ALL_PARTIES_DATA = "GET_ALL_PARTIES_DATA";
export const GET_ALL_VENDORS_DATA = "GET_ALL_VENDORS_DATA";
export const GET_VENDOR_LEDGER_DATA = "GET_VENDOR_LEDGER_DATA";
export const GET_TRIP_LEDGER_DATA = "GET_TRIP_LEDGER_DATA";
export const GET_TRIP_LEDGER_DATA_V2 = "GET_TRIP_LEDGER_DATA_V2"
export const GET_SINGLE_PARTY_LEDGER_DATA = "GET_SINGLE_PARTY_LEDGER_DATA";
export const GET_SINGLE_PARTY_PDF_REPORT = "GET_SINGLE_PARTY_PDF_REPORT";
export const GET_SINGLE_VENDOR_PDF_REPORT = "GET_SINGLE_VENDOR_PDF_REPORT";
export const GET_SINGLE_VENDOR_LEDGER_DATA = "GET_SINGLE_VENDOR_LEDGER_DATA";
export const GET_SINGLE_TRIP_DATA = "GET_SINGLE_TRIP_DATA";
export const GET_SINGLE_EXPENSE = "GET_SINGLE_EXPENSE";
export const TOGGLE_SEARCH_BAR = "TOGGLE_SEARCH_BAR";
export const GET_ALL_LOCATIONS_FOR_PROFILE = "GET_ALL_LOCATIONS_FOR_PROFILE";
export const GET_ALL_LOCATIONS_STATES = "GET_ALL_LOCATIONS_STATES";
export const GET_USER_DETAILS_FOR_PROFILE = "GET_USER_DETAILS_FOR_PROFILE";
export const GET_PAYMENT_CONFIG = "GET_PAYMENT_CONFIG";
export const GET_DETAILS_FROM_GST = "GET_DETAILS_FROM_GST";
export const GET_VEHICLE_CONFIG = "GET_VEHICLE_CONFIG";
export const GET_TRIP_PDF = "GET_TRIP_PDF";
export const TOGGLE_OVERLAY = "TOGGLE_OVERLAY";
export const TOGGLE_CHAT_SUPPORT = "TOGGLE_CHAT_SUPPORT";
export const FREE_TRAIL_SHOWN = "FREE_TRAIL_SHOWN";

// USER PROFILE FLOW.
export const ADD_PASSBOOK_PHOTO_UPLOAD = "ADD_PASSBOOK_PHOTO_UPLOAD";
export const BANK_ACCOUNTS = "BANK_ACCOUNTS";

//DRIVER FLOW.
export const FETCH_ALL_DRIVERS = "FETCH_ALL_DRIVERS";

// CREATE TRIP DATA
export const GET_PARTY_LIST = "GET_PARTY_LIST";
export const GET_VEHICLE_LIST = "GET_VEHICLE_LIST";
export const GET_SUPPLIER_LIST = "GET_SUPPLIER_LIST";
export const GET_DRIVER_LIST = "GET_DRIVER_LIST";
export const GET_CREATE_TRIP_ORIGIN_LOCATIONS = "GET_CREATE_TRIP_ORIGIN_LOCATIONS";
export const GET_CREATE_TRIP_DEST_LOCATIONS = "GET_CREATE_TRIP_DEST_LOCATIONS";
export const GET_ALL_LOCATIONS = "GET_ALL_LOCATIONS";
export const ADD_CUSTOM_LOCATION = "ADD_CUSTOM_LOCATION";
export const ADD_CUSTOM_LOCATION_PROFILE = "ADD_CUSTOM_LOCATION_PROFILE";


export const UPDATE_TRIP_EDIT_ARROW_FLAGS = "UPDATE_TRIP_EDIT_ARROW_FLAGS";
export const UPDATE_TRIP_EDIT_MODAL_FLAGS = "UPDATE_TRIP_EDIT_MODAL_FLAGS";
export const UPDATE_CURRENT_PARTY_DEDUCTION = "UPDATE_CURRENT_PARTY_DEDUCTION";
export const UPDATE_CURRENT_PARTY_EXPENSE = "UPDATE_CURRENT_PARTY_EXPENSE";
export const UPDATE_CURRENT_PARTY_ADVANCE = "UPDATE_CURRENT_PARTY_ADVANCE";
export const UPDATE_CURRENT_PARTY_PAYMENT = "UPDATE_CURRENT_PARTY_PAYMENT";

export const UPDATE_CURRENT_VENDOR_DEDUCTION = "UPDATE_CURRENT_VENDOR_DEDUCTION";
export const UPDATE_CURRENT_VENDOR_EXPENSE = "UPDATE_CURRENT_VENDOR_EXPENSE";
export const UPDATE_CURRENT_VENDOR_ADVANCE = "UPDATE_CURRENT_VENDOR_ADVANCE";
export const UPDATE_CURRENT_VENDOR_PAYMENT = "UPDATE_CURRENT_VENDOR_PAYMENT";

export const UPDATE_CURRENT_TRUCK_HIRE_COST_EXPENSE = "UPDATE_CURRENT_TRUCK_HIRE_COST_EXPENSE";
export const UPDATE_CREATE_TRIP_RESPONSE = "UPDATE_CREATE_TRIP_RESPONSE";

export const UPDATE_CREATE_TRIP_DATA = "UPDATE_CREATE_TRIP_DATA";

export const UPDATE_CREATE_TRIP_PARTY_ADVANCE = "UPDATE_CREATE_TRIP_PARTY_ADVANCE";
export const UPDATE_CREATE_TRIP_PARTY_DEDUCTION = "UPDATE_CREATE_TRIP_PARTY_DEDUCTION";
export const UPDATE_CREATE_TRIP_PARTY_EXPENSE = "UPDATE_CREATE_TRIP_PARTY_EXPENSE";

export const UPDATE_CREATE_TRIP_VENDOR_ADVANCE = "UPDATE_CREATE_TRIP_VENDOR_ADVANCE";
export const UPDATE_CREATE_TRIP_VENDOR_DEDUCTION = "UPDATE_CREATE_TRIP_VENDOR_DEDUCTION";
export const UPDATE_CREATE_TRIP_VENDOR_EXPENSE = "UPDATE_CREATE_TRIP_VENDOR_EXPENSE";

export const UPDATE_CREATE_TRIP_PARTY_ADVANCE_INDEX = "UPDATE_CREATE_TRIP_PARTY_ADVANCE_INDEX";
export const UPDATE_CREATE_TRIP_PARTY_DEDUCTION_INDEX = "UPDATE_CREATE_TRIP_PARTY_DEDUCTION_INDEX";
export const UPDATE_CREATE_TRIP_PARTY_EXPENSE_INDEX = "UPDATE_CREATE_TRIP_PARTY_EXPENSE_INDEX";

export const UPDATE_CREATE_TRIP_VENDOR_ADVANCE_INDEX = "UPDATE_CREATE_TRIP_VENDOR_ADVANCE_INDEX";
export const UPDATE_CREATE_TRIP_VENDOR_DEDUCTION_INDEX = "UPDATE_CREATE_TRIP_VENDOR_DEDUCTION_INDEX";
export const UPDATE_CREATE_TRIP_VENDOR_EXPENSE_INDEX = "UPDATE_CREATE_TRIP_VENDOR_EXPENSE_INDEX";

export const UPDATE_VENDOR_NAME = "UPDATE_VENDOR_NAME";

export const UPDATE_ADD_PARTY_FLAG = "UPDATE_ADD_PARTY_FLAG";
export const ADD_PARTY = "ADD_PARTY";
export const ADD_VEHICLE = "ADD_VEHICLE";
export const UPDATE_VEHICLE = "UPDATE_VEHICLE";
export const DELETE_CREATE_TRIP_TRANSACTIONS = "DELETE_CREATE_TRIP_TRANSACTIONS";
export const DELETE_CREATE_TRIP_TRUCK_HIRE_COST = "DELETE_CREATE_TRIP_TRUCK_HIRE_COST";
export const ADD_TRIP_POD = "ADD_TRIP_POD";
export const ADD_TRIP_POD_CTA = "ADD_TRIP_POD_CTA";

// ---------------------------- VEHICLE
export const UPDATE_CURRENT_VEHICLE_DATA = "UPDATE_CURRENT_VEHICLE_DATA";
export const GET_VEHICLE_LEDGER_DATA = "GET_VEHICLE_LEDGER_DATA";
export const UPDATE_CREATE_VEHICLE_OPEN = "UPDATE_CREATE_VEHICLE_OPEN";
export const UPDATE_CREATE_VEHICLE_HIRED = "UPDATE_CREATE_VEHICLE_HIRED";
export const UPDATE_CREATE_VEHICLE_ASSIGN_DRIVER = "UPDATE_CREATE_VEHICLE_ASSIGN_DRIVER";
export const UPDATE_CREATE_VEHICLE_VENDOR_MODAL_OPEN = "UPDATE_CREATE_VEHICLE_VENDOR_MODAL_OPEN";
export const UPDATE_CREATE_VEHICLE_ADD_VENDOR_OPEN = "UPDATE_CREATE_VEHICLE_ADD_VENDOR_OPEN";
export const GET_ALL_VENDOR_DATA = "GET_ALL_VENDOR_DATA";
export const GET_ALL_DRIVER_DATA = "GET_ALL_DRIVER_DATA";
export const UPDATE_NEW_VENDOR_DATA = "UPDATE_NEW_VENDOR_DATA";
export const UPDATE_NEW_DRIVER_DATA = "UPDATE_NEW_DRIVER_DATA";
export const VEHICLE_TYPES_CONFIG = "VEHICLE_TYPES_CONFIG";
export const SINGLE_TRUCK_DATA = "SINGLE_TRUCK_DATA";
export const P_AND_L = "P_AND_L";
export const TRIP_EXPENSES = "TRIP_EXPENSES";
export const ADD_EXPENSE_PHOTO_UPLOAD = "ADD_EXPENSE_PHOTO_UPLOAD";
export const VEHICLE_EXPENSE_TYPE = "VEHICLE_EXPENSE_TYPE";
export const DRIVER_EXPENSE_TYPE = "DRIVER_EXPENSE_TYPE";
export const TRIP_EXPENSE_TYPES = "TRIP_EXPENSE_TYPES";
export const VEHIClE_PROFIT_AND_LOSS_MONTHLY = "VEHIClE_PROFIT_AND_LOSS_MONTHLY";
export const VEHIClE_PROFIT_AND_LOSS_MONTHLY_PDF = "VEHIClE_PROFIT_AND_LOSS_MONTHLY_PDF";
export const GET_DOCUMENT_CONFIG = "GET_DOCUMENT_CONFIG";
export const GET_EMI_SELECT_DATE = "GET_EMI_SELECT_DATE";
export const GET_TRUCK_BOOK = "GET_TRUCK_BOOK";
export const GET_VEHICLE_DOCUMENTS_BOOK = "GET_VEHICLE_DOCUMENTS_BOOK";
export const GET_VEHICLE_DOCUMENT_PDF = "GET_VEHICLE_DOCUMENT_PDF";
export const GET_TRIP_PNL_MONTHS = "GET_TRIP_PNL_MONTHS";
export const GET_TRIP_PNL_MONTHLY_PDF = "GET_TRIP_PNL_MONTHLY_PDF";
export const GET_CALENDER_DATES = "GET_CALENDER_DATES";
export const GET_MAINTENANCE_UPCOMING = "GET_MAINTENANCE_UPCOMING";
export const SINGLE_DRIVER_DETAILS = "SINGLE_DRIVER_DETAILS";
export const GET_DRIVER_DEDUCTION_TYPES = "GET_DRIVER_DEDUCTION_TYPES";
export const GET_DRIVER_ADDITION_TYPES = "GET_DRIVER_ADDITION_TYPES";
export const GET_SINGLE_DRIVER_TRANSACTION = "GET_SINGLE_DRIVER_TRANSACTION";
export const GET_DRIVER_NAME_LIST = "GET_DRIVER_NAME_LIST";
export const GET_SINGLE_VENDOR_DETAILS = "GET_SINGLE_VENDOR_DETAILS";
export const GET_SIM_TRACKING_DETAILS = "GET_SIM_TRACKING_DETAILS";
export const GET_LOCATIONS_FOR_SIM_TRACKING = "GET_LOCATIONS_FOR_SIM_TRACKING";
export const GET_ONLINE_DRIVER_TRANSACTION = "GET_ONLINE_DRIVER_TRANSACTION";
export const GET_SINGLE_DRIVER_KHATA_PDF = "GET_SINGLE_DRIVER_KHATA_PDF";

export const VEHICLE_STATUS = { AVAILABLE: "Available", ONTRIP: "On Trip" }
export const VEHICLE_STATUS_REV = { Available: "AVAILABLE", "On Trip": "ONTRIP" }

export const VEHICLE_STATUS_VALUES = [{ requestStatus: ["AVAILABLE"], displayName: "Available" },
{ requestStatus: ["ONTRIP"], displayName: "On Trip" },
{ requestStatus: ["AVAILABLE_ONTRIP"], displayName: "Available & On Trip" }]

export const VEHICLE_STATUS_FILTER_DATA = {
  "Available & On Trip": ["AVAILABLE", "ONTRIP"],
  "Available": ["AVAILABLE"],
  "On Trip": ["ONTRIP"]
}

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const WEEK_DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];


export const TRIP_DISPLAY_STATUS = ["Started", "Completed", "POD Received", "POD Submitted", "Settled"];
export const TRIP_STATUS = { STARTED: 1, COMPLETED: 2, POD_RECEIVED: 3, POD_SUBMITTED: 4, PAYMENT_RECEIVED: 5 }
export const TRIP_ACTIONS = {
  'STARTED': 'Complete Trip',
  'COMPLETED': 'Received POD',
  'POD_RECEIVED': 'Mark POD Submitted',
  'POD_SUBMITTED': 'Settle Amount',
  'PAYMENT_RECEIVED': 'View Trip'
};
export const TRIP_ACTIONS_SUPPLIER = {
  'STARTED': 'Complete Trip',
  'COMPLETED': 'Received POD',
  'POD_RECEIVED': 'Mark POD Submitted',
  'POD_SUBMITTED': 'Settle Supplier Balance',
  'PAYMENT_RECEIVED': 'View Trip'
}
export const TRIP_ACTIONS_DWEB = {
  'STARTED': 'Mark Delivered',
  'COMPLETED': 'Mark POD Received',
  'POD_RECEIVED': 'Mark POD Submitted',
  'POD_SUBMITTED': 'Settle Supplier Balance',
  'PAYMENT_RECEIVED': 'Settle Supplier Balance'
};
export const TRIP_ACTIONS_DWEB_PARTY = {
  'STARTED': 'Mark Delivered',
  'COMPLETED': 'Mark POD Received',
  'POD_RECEIVED': 'Mark POD Submitted',
  'POD_SUBMITTED': 'Settle Party Balance',
  'PAYMENT_RECEIVED': 'Settle Party Balance'
};
export const TRIP_ACTIONS_FORM_LABELS = {
  'STARTED': {
    'date': 'Completed Date',
    'suceess': 'Trip Completed Successfully!',
    'failure': 'Trip Completion Failed'
  },
  'COMPLETED': {
    'date': 'POD Received Date',
    'suceess': 'Trip Updated Successfully!',
    'failure': 'Trip Update Failed'
  },
  'POD_RECEIVED': {
    'date': 'POD Submitted Date',
    'suceess': 'Trip POD Submitted Successfully!',
    'failure': 'Trip POD Submit Failed'
  },
  'POD_SUBMITTED': {
    'date': 'Settlement Date',
    'suceess': 'Trip Settled Successfully!',
    'failure': 'Trip Settle Failed'
  },
  'PAYMENT_RECEIVED': 'View Trip'
};
export const TRIP_STATUS_LABELS = {
  'STARTED': 'Started',
  'COMPLETED': 'Completed',
  'POD_RECEIVED': 'POD Received',
  'POD_SUBMITTED': 'POD Submitted',
  'PAYMENT_RECEIVED': 'Payment Received',
  'SETTLED': 'Settled'
};
export const TRIP_STATUS_DIALOG_TITLES = {
  'STARTED': 'Mark Completed',
  'COMPLETED': 'Mark POD Received',
  'POD_RECEIVED': 'Mark POD Submitted',
  'POD_SUBMITTED': 'Settle Amount',
  'PAYMENT_RECEIVED': 'View Trip'
};
export const TRIP_STATUS_DIALOG_LABELS = {
  'STARTED': 'Trip Completed Date',
  'COMPLETED': 'POD Received Date',
  'POD_RECEIVED': 'POD Submitted Date',
  'POD_SUBMITTED': 'Settlement Date',
  'PAYMENT_RECEIVED': 'View Trip'
};
export const TRIP_TRANSACTION_FILTER = {
  'TRIPS_PAYMENTS': ["TRIPS", "PAYMENTS"],
  'TRIPS': ["TRIPS"],
  'PAYMENTS': ["PAYMENTS"],
};
export const TRIP_TRANSACTION_FILTER_LIST = [
  {
    value: "TRIPS_PAYMENTS",
    displayName: "Trips & Payments"
  },
  {
    value: "TRIPS",
    displayName: "Trips"
  },
  {
    value: "PAYMENTS",
    displayName: "Payments"
  }
];
export const PAYMENT_CHIPS = [
  { key: 0, label: "Cash" },
  { key: 1, label: "Cheque" },
  { key: 2, label: "UPI" },
  { key: 3, label: "Bank Transfer" },
  { key: 4, label: "Others" },
];

export const TRIP_FILTER_STATUS = {
  ACTIVE: "Active Trips (Not Settled)",
  ALL: "All Trips",
  DUE: "Due Trips",
  SETTLED: "Settled Trips",
  IN_PROGRESS: "In Progress ( Started )"
}
export const PAYMENT_FILTER_STATUS = {
  all: "All Payments",
  fastag: "FASTag Recharge",
  fuelcard: "Diesel Card Recharge",
  vendor: "Supplier Payment",
  driver: "Driver Payment",
  shop: "Shop Payment",
  customer: "Payment From Party"
}

export const TRIP_FILTER_STATUS_MAPPING = {
  ACTIVE: ["STARTED", "COMPLETED", "POD_RECEIVED", "POD_SUBMITTED"],
  ALL: ["STARTED", "COMPLETED", "POD_RECEIVED", "POD_SUBMITTED", "PAYMENT_RECEIVED"],
  DUE: ["POD_SUBMITTED"],
  SETTLED: ["PAYMENT_RECEIVED"],
  IN_PROGRESS: ["STARTED"]
}

// Regexes
export const MOBILE_REGEX = /^[0-9]{10}$/;

// Error messages
export const CREATE_PARTY_EMPTY_NAME_ERROR = "Please enter party name.";
export const CREATE_PARTY_INVALID_NUMBER_ERROR = "Invalid mobile number";

export const CREATE_VENDOR_EMPTY_NAME_ERROR = "Please enter vendor name.";
export const CREATE_VENDOR_INVALID_NUMBER_ERROR = "Invalid mobile number";

export const CREATE_DRIVER_EMPTY_NAME_ERROR = "Please enter Driver name.";
export const CREATE_DRIVER_INVALID_NUMBER_ERROR = "Invalid mobile number";

export const CREATE_VEHICLE_VEHICLE_NUMBER_ERROR = "Vehicle number should be like KA 01 AA 1234";
export const CREATE_VEHICLE_VEHICLE_TYPE_ERROR = "Please select capacity";
export const CREATE_VEHICLE_VEHICLE_BODY_TYPE_ERROR = "Please select body type";
export const CREATE_VEHICLE_VENDOR_NAME_ERROR = "Please select vendor";
export const CREATE_VEHICLE_DRIVER_NUMBER_ERROR = "Enter valid mobile number";

export const CREATE_TRIP_PARTY_NAME_ERROR = "Please select party";
export const CREATE_TRIP_TRUCK_NO_ERROR = "Please select truck";
export const CREATE_TRIP_ORIGIN_ERROR = "Please select origin";
export const CREATE_TRIP_DESTINATION_ERROR = "Please select destination";
export const CREATE_TRIP_AMOUNT_ERROR = "Please enter total amount";
export const CREATE_TRIP_UNIT_COUNT_ERROR = "Please enter count";

export const EMPTY_EXPENSE_ERROR = "Please enter expense amount";
export const EMPTY_BILLABLE_EXPENSE_ERROR = "Please enter amount";
export const EMPTY_EXPENSE_TYPE_ERROR = "Please select type";

export const EMPTY_DEDUCTION_ERROR = "Please enter deduction amount";
export const EMPTY_DEDUCTION_TYPE_ERROR = "Please select type";

export const EMPTY_ADVANCE_ERROR = "Please enter advance amount";
export const EMPTY_PAYMENT_ERROR = "Please enter payment amount";
export const CREATE_DRIVER_NUMBER_ERROR = "Please enter Driver number";
export const CREATE_DRIVER_NAME_ERROR = "Please enter Driver name"

//Dweb Parties
export const GET_PARTY_MONTHLY_BALANCES = "GET_PARTY_MONTHLY_BALANCES";
export const GET_PARTY_TRIP_SPARKLINE = "GET_PARTY_TRIP_SPARKLINE";
export const GET_PARTY_PAYMENTS = "GET_PARTY_PAYMENTS";
export const GET_PARTY_SUGGESTIONS_TRIPS = "GET_PARTY_SUGGESTIONS_TRIPS";

export const ADD_PARTY_CHARGE_SUCCESS = "Party Charges Added Successfully!";
export const ADD_PARTY_CHARGE_FAILURE = "Failed";
export const ADD_VENDOR_ADVANCE_SUCCESS = "Supplier Advance Added Successfully!"
export const ADD_VENDOR_ADVANCE_FAILURE = "Supplier Advance Add Failed!"
export const ADD_PARTY_ADVANCE_SUCCESS = "Party Advance Added Successfully!"
export const ADD_PARTY_ADVANCE_FAILURE = "Party Advance Add Failed!"
export const ADD_VENDOR_PAYMENT_SUCCESS = "Supplier Payment Added Successfully!"
export const ADD_VENDOR_PAYMENT_FAILURE = "Supplier Payment Add Failed!"
export const ADD_PARTY_PAYMENT_SUCCESS = "Party Payment Added Successfully!"
export const ADD_PARTY_PAYMENT_FAILURE = "Party Payment Add Failed!";
export const ADD_PARTY_DEDUCTION_SUCCESS = "Party Deduction Added Successfully!"
export const ADD_PARTY_DEDUCTION_FAILURE = "Party Deduction Add Failed!"
export const ADD_TRIP_EXPENS_SUCCESS = "Trip Expense added Sucessfully!";
export const ADD_TRIP_EXPENS_FAILURE = "Add Trip Expense Failed!";
export const ADD_VENDOR_DEDUCTION_SUCCESS = "Supplier Deduction Added Successfully!";
export const ADD_VENDOR_DEDUCTION_FAILURE = "Add Supplier Deduction Failed!";
export const ADD_VENDOR_CHARGE_SUCCESS = "Supplier Charge Added Successfully"
export const UPDATE_TRIP_EXPENSE_SUCCESS = "Trip Expense Updated Successfully!";
export const UPDATE_PARTY_CHARGE_SUCCESS = "Party Charge Updated Successfully!";
export const UPDATE_PARTY_REDUCTION_SUCCESS = "Party Deduction Updated Successfully";
export const UPDATE_PARTY_ADVANCE_SUCCESS = "Party Advance Updated Successfully";
export const UPDATE_PARTY_PAYMENT_SUCCESS = "Party Payment Updated Successfully";
export const UPDATE_VENDOR_CHARGE_SUCCESS = "Supplier Charge Updated Successfully!";
export const UPDATE_VENDOR_DEDUCTION_SUCCESS = "Supplier Deduction Updated Successfully!";
export const UPDATE_VENDOR_ADVANCE_SUCCESS = "Supplier Advance Updated Successfully!";
export const UPDATE_VENDOR_PAYMENT_SUCCESS = "Supplier Payment Updated Successfully!";
export const PAYMENT_METHODS_LIST = [
  { value: "Cash", label: "Cash" },
  { value: "Cheque", label: "Cheque" },
  { value: "UPI", label: "UPI" },
  { value: "Bank Transfer", label: "Bank Transfer" },
  { value: "Fuel", label: "Fuel" },
  { value: "Others", label: "Others" },
];
export const SINGLE_PARTY_PAYMENT = 'SINGLE_PARTY_PAYMENT';
export const GET_SINGLE_PARTY_PAYMENT = 'GET_SINGLE_PARTY_PAYMENT';
export const GET_PARTY_COMPANY_DETAILS = 'GET_PARTY_COMPANY_DETAILS';
export const UPDATE_PARTY_PAYMENT_TAB_FILTER = "UPDATE_PARTY_PAYMENT_TAB_FILTER";
export const UPDATE_PARTY_TRIPS_TAB_FILTER = "UPDATE_PARTY_TRIPS_TAB_FILTER";
export const GET_PARTY_SETTINGS = 'GET_PARTY_SETTINGS';

export const GET_SUBSCRIPTION_PLAN = "GET_SUBSCRIPTION_PLAN";
export const GET_SUBSCRIPTION_STATUS = "GET_SUBSCRIPTION_STATUS";
export const UPDATE_CHAT_VIEW = 'UPDATE_CHAT_VIEW';
export const GET_COLLECTION_REMINDER = 'GET_COLLECTION_REMINDER';
export const UPDATE_COLLECTION_REMINDER = 'UPDATE_COLLECTION_REMINDER';
export const DELETE_COLLECTION_REMINDER = 'DELETE_COLLECTION_REMINDER';
export const GET_COUPON_APPLIED_STATUS = "GET_COUPON_APPLIED_STATUS";
export const UPDATE_FREE_TRIAL_MODAL = "UPDATE_FREE_TRIAL_MODAL";
export const UPDATE_PAYMENT_FAILED_MODAL = "UPDATE_PAYMENT_FAILED_MODAL";
export const RESET_PAYMENTS = "RESET_PAYMENTS";
export const GET_PARTY_TRANSACT_HISTORY = "GET_PARTY_TRANSACT_HISTORY";
export const GET_PARTY_DETAILS = "GET_PARTY_DETAILS";

// ****************************Online Bilty**************************************
export const LOAD_ELR = "LOAD_ELR";
export const ELR_GST_INFO = "ELR_GST_INFO";
export const GET_CONSIGNEE_LIST = "GET_CONSIGNEE";
export const GET_CONSIGNOR_LIST = "GET_CONSIGNOR";
export const ADD_CONSIGNEE = "ADD_CONSIGNEE";
export const ADD_CONSIGNOR = "ADD_CONSIGNOR";
export const MATERIAL_LIST = "MATERIAL_LIST";
export const ELR_INFO = "ELR_INFO";
export const GET_INSURANCE_PROVIDERS = "GET_INSURANCE_PROVIDERS";
export const BILTY_DATA_POPULATED = "BILTY_DATA_POPULATED";
export const BILTY_CONTINUE_CLICK = "BILTY_CONTINUE_CLICK";
export const GET_CONSIGNEE_PDF = "GET_CONSIGNEE_PDF";
export const GET_CONSIGNOR_PDF = "GET_CONSIGNOR_PDF";
export const TRIP_CHARGE_TYPES = "TRIP_CHARGE_TYPES";
export const TRIP_DEDUCTION_TYPES = "TRIP_DEDUCTION_TYPES";

// ********************************* MultiUser Flow ***********************************
export const GET_MULTI_USER_LIST = "GET_MULTI_USER_LIST";

// ********************************* In App Reports ******************************
export const TRUCK_INCOME_REPORT = "TRUCK_INCOME_REPORT";
export const GET_VEHICLE_MONTHLY_PNL_PDF = "GET_VEHICLE_MONTHLY_PNL_PDF";
export const GET_VEHICLE_MONTHLY_PNL_PDF_LINK = "GET_VEHICLE_MONTHLY_PNL_PDF_LINK";
export const GET_TRUCK_INCOME_EXCEL = "GET_TRUCK_INCOME_EXCEL";
export const GET_PARTY_INCOME_REPORT = "GET_PARTY_INCOME_REPORT";
export const PARTY_INCOME_EXCEL = "PARTY_INCOME_EXCEL";
export const GET_PARTY_MONTHLY_BALANCES_FOR_REPORTS = "GET_PARTY_MONTHLY_BALANCES_FOR_REPORTS";
export const GET_PROFIT_LOSS_REPORT = "GET_PROFIT_LOSS_REPORT";
export const GET_PROFIT_LOSS_PDF_V2 = "GET_PROFIT_LOSS_PDF_V2";
export const GET_PROFIT_LOSS_PDF_DOWNLOAD_V2 = "GET_PROFIT_LOSS_PDF_DOWNLOAD_V2";
export const GET_SUPPLIER_LEDGER_PDF_V2 = "GET_SUPPLIER_LEDGER_PDF_V2";
export const GET_SUPPLIER_LEDGER_PDF_DOWNLOAD_V2 = "GET_SUPPLIER_LEDGER_PDF_DOWNLOAD_V2";
export const GET_PARTY_LEDGER_PDF_V2 = "GET_PARTY_LEDGER_PDF_V2";
export const GET_PARTY_LEDGER_PDF_DOWNLOAD_V2 = "GET_PARTY_LEDGER_PDF_DOWNLOAD_V2";

//  ************************************* Multi Supplier *******************************
export const SUPPLIER_TRANSACTION_LOG = "SUPPLIER_TRANSACTION_LOG";
export const GET_SUPPLIER_PAYMENT_DATA = "GET_SUPPLIER_PAYMENT_DATA";
export const GET_SUPPLIER_TRANSACT_HISTORY = "GET_SUPPLIER_TRANSACT_HISTORY";

export const UPDATE_TRIPS_PAGE_NO = "UPDATE_TRIPS_PAGE_NO";
export const UPDATE_BACK_BUTTON = "UPDATE_BACK_BUTTON";



/*  ************************************* Online Payment *******************************/
export const TRANSACTION_HISTORY = "TRANSACTION_HISTORY";
export const GET_TRIP_SUGGESTION_SUPPLIER = "GET_TRIP_SUGGESTION_SUPPLIER";
export const GET_ONLINE_PAYMENT_CONFIG = "GET_ONLINE_PAYMENT_CONFIG";

export const GET_ALL_SUGGESTED_ORIGIN_LOCATIONS = "GET_ALL_SUGGESTED_ORIGIN_LOCATIONS";
export const GET_ALL_SUGGESTED_DESTINATION_LOCATIONS = "GET_ALL_SUGGESTED_DESTINATION_LOCATIONS";


// ************************************* Invoices *************************************.
export const GET_INVOICES_LIST = "GET_INVOICES_LIST";
export const GET_INVOICE_CONFIG = "GET_INVOICE_CONFIG";
export const GET_INVOICES_TRIPS = "GET_INVOICES_TRIPS";
export const GET_INVOICE_CUSTOMERS = "GET_INVOICE_CUSTOMERS";
export const GET_SINGLE_INVOICE = "GET_SINGLE_INVOICE";
export const TOGGLE_EDIT_INVOICE_FLAG = "TOGGLE_EDIT_INVOICE_FLAG";
export const GET_SINGLE_INVOICE_PDF = "GET_SINGLE_INVOICE_PDF";

export const INVOICE_STATUS = [
  { displayName: 'All Invoices', value: 'all' },
  { displayName: 'Paid Invoices', value: 'paid' },
  { displayName: "Unpaid Invoices", value: 'unpaid' }
]


/**************************************** SHOPS ****************************************/
export const GET_SHOP_KHATA_DATA = "GET_SHOP_KHATA_DATA";
export const ADD_SHOP = "ADD_SHOP";
export const GET_SINGLE_SHOP_DETAILS = "GET_SINGLE_SHOP_DETAILS";


/**************************************** Diesel Card ****************************************/
export const GET_DIESEL_CARD_LIST = "GET_DIESEL_CARD_LIST";
export const GET_FUEL_CARD_DRIVERS_LIST = "GET_FUEL_CARD_DRIVERS_LIST";
export const GET_SINGLE_DIESEL_CARD = "GET_SINGLE_DIESEL_CARD";
export const GET_DIESEL_CARD_TRANSACTION_DETAILS = "GET_DIESEL_CARD_TRANSACTION_DETAILS";
export const GET_CASHBACK_STEPPER = "GET_CASHBACK_STEPPER";
export const CALCULATE_CASHBACK = "CALCULATE_CASHBACK";

/***************************************** FASTag***********************************************/
export const GET_FASTAG_VEHICLES_DATA = "GET_FASTAG_VEHICLES_DATA";
export const GET_SINGLE_FASTTAG_DETAILS = "GET_SINGLE_FASTTAG_DETAILS";
export const GET_FASTTAG_RECHARGE_STATUS = "GET_FASTTAG_RECHARGE_STATUS";
export const GET_WALLET_BALANCE = "GET_WALLET_BALANCE";
export const GET_SINGLE_SHOP_KHATA_PDF = "GET_SINGLE_SHOP_KHATA_PDF";

/***************************************** EXPENSES ***********************************************/
export const GET_EXPENSES_SPARKLINE_DATA = "GET_EXPENSES_SPARKLINE_DATA";
export const GET_TRUCK_EXPENSES_DATA = "GET_TRUCK_EXPENSES_DATA";
export const GET_TRIP_EXPENSES_DATA = "GET_TRIP_EXPENSES_DATA";
export const GET_OFFICE_EXPENSES_DATA = "GET_OFFICE_EXPENSES_DATA";
export const UPDATE_CURRENT_FILTER_MONTH = "UPDATE_CURRENT_FILTER_MONTH";
export const GET_PNL_EXPENSES = "GET_PNL_EXPENSES";
export const ALL_VEHICLE_EXPENSES= "ALL_VEHICLE_EXPENSES";
export const ALL_TRIP_EXPENSES = "ALL_TRIP_EXPENSES";
export const ALL_OFFICE_EXPENSES_TYPES = "ALL_OFFICE_EXPENSES_TYPES";
export const GET_JOURNEYS = "GET_JOURNEYS";
export const SELECT_JOURNEY = "SELECT_JOURNEY";